// 外見動画をブラウザで最適化するときの出力仕様（純関数）

export const MAX_FPS = 30;

// 出力の箱（長辺, 短辺）。キャラ動画は Level 4.0 に収まる 1920x1080
const BOX = { character: [1920, 1080], mini: [480, 480] };

const STANDARD_FPS = [24000 / 1001, 24, 25, 30000 / 1001, 30];
const OPTIMIZABLE_EXTS = ['.mp4', '.mov'];
const OPTIMIZABLE_TYPES = ['video/mp4', 'video/quicktime'];

export const specKindOf = (slotKey) => (slotKey === 'idle_mini' ? 'mini' : 'character');

const extOf = (name) => {
    const dot = name.lastIndexOf('.');
    return dot > 0 ? name.slice(dot).toLowerCase() : '';
};

/** 最適化の対象か（MP4 / MOV。WebM は素通し） */
export const isOptimizable = (file) => {
    if (!file || !file.name) return false;
    const ext = extOf(file.name);
    return ext ? OPTIMIZABLE_EXTS.includes(ext) : OPTIMIZABLE_TYPES.includes(file.type);
};

// 1080*(480/1350) が 383.999… になるような誤差で1段下がらないよう、わずかに足してから切り下げる
const floorTo = (v, m) => Math.max(m, Math.floor(v / m + 1e-9) * m);

/**
 * 出力の寸法。拡大はせず箱に収める。幅・高さは2の倍数（yuv420p）に切り下げる
 */
export const calcTargetSize = (width, height, slotKey) => {
    const [boxLong, boxShort] = BOX[specKindOf(slotKey)];
    const scale = Math.min(1, boxLong / Math.max(width, height), boxShort / Math.min(width, height));
    return { width: floorTo(width * scale, 2), height: floorTo(height * scale, 2) };
};

/** 縦横比の差は伸ばさず中央を切り抜く範囲（cover） */
export const calcCropRect = (width, height, target) => {
    const scale = Math.max(target.width / width, target.height / height);
    const cropWidth = Math.min(width, target.width / scale);
    const cropHeight = Math.min(height, target.height / scale);
    return { x: (width - cropWidth) / 2, y: (height - cropHeight) / 2, width: cropWidth, height: cropHeight };
};

/** 出力のフレームレート。標準値の近く（±5%）はその値に揃え、上限は 30 */
export const calcTargetFrameRate = (rate) => {
    if (!(rate > 0)) return MAX_FPS;
    if (rate > MAX_FPS * 1.05) return MAX_FPS;
    const nearest = STANDARD_FPS.reduce((a, b) => (Math.abs(b - rate) < Math.abs(a - rate) ? b : a));
    if (Math.abs(nearest - rate) / nearest <= 0.05) return nearest;
    return Math.min(MAX_FPS, Math.round(rate));
};

export const optimizedFileName = (name) => {
    const dot = name.lastIndexOf('.');
    return (dot > 0 ? name.slice(0, dot) : name) + '.mp4';
};
